import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FooterSupport } from "../../assetData/Data";
import { BsSend } from "react-icons/bs";
import { errorNotify } from "../../Services/Notification";
import { logo } from "../../assetData/images";
import { FaPhoneAlt } from "react-icons/fa";
import { MdMail } from "react-icons/md";

const Footer = () => {
  const [email, setEmail] = useState();
  const [closePopup, setClosePopup] = useState(true);

  const handleNewsletter = (e) => {
    e.preventDefault();
    setEmail("");
  };

  const finYear = sessionStorage.getItem("finYear");
  const finYearID = sessionStorage.getItem("finYearID");
  const token = sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token");

  const handleNavbarAccess = () => {
    if (token && !finYear && !finYearID) {
      errorNotify("Please Select Starting Financial Year From");
    } else {
    }
  };

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <div>
      <div className=" w-full bg-[#231C42] px-[2%] py-16">
        <div className="mx-auto max-w-[1440px] px-[16px] md:px-0">
          <div className="grid justify-between gap-[5px]  md:w-full md:grid-cols-3 ">
            <div className=" flex w-[50%] justify-evenly gap-5 md:w-[100%] ">
              <div className="">
                <Link
                  onClick={() => handleNavbarAccess()}
                  to={token && !finYear && !finYearID ? false : "/"}
                >
                  <img className="w-full max-w-[144px]" src={logo} alt="" />
                </Link>
                <p className="pt-[40px] font-open text-[14px] leading-[24px] text-[#D9DBE1]">
                  Copyright © {currentYear} i4invest.
                </p>
                <p className="pb-[40px] font-open text-[14px] leading-[24px] text-[#D9DBE1]">
                  All rights reserved
                </p>
                <ul className="flex items-center justify-start gap-4">
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      to={
                        token && !finYear && !finYearID
                          ? false
                          : "https://www.facebook.com/people/i4invest/100094283136053/"
                      }
                    >
                      <img
                        className="w-full max-w-[30px]"
                        src="images/facebook.png"
                        alt=""
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      to={
                        token && !finYear && !finYearID
                          ? false
                          : "https://www.linkedin.com/company/91032029/admin/dashboard/"
                      }
                    >
                      <img
                        className="w-full max-w-[30px]"
                        src="images/linked.png"
                        alt=""
                      />
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="">
                <h3 className="pb-[15px] font-open text-[20px] font-[600] leading-[30px] text-[#ffffff] md:pb-[24px]">
                  Company
                </h3>
                <ul className="flex flex-col gap-2">
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      to={token && !finYear && !finYearID ? false : "/about"}
                    >
                      About us
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      to={token && !finYear && !finYearID ? false : "/blog"}
                    >
                      Blogs
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      to={token && !finYear && !finYearID ? false : "/services"}
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      to={token && !finYear && !finYearID ? false : "/pricing"}
                    >
                      Pricing
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      to={token && !finYear && !finYearID ? false : "/faq"}
                    >
                      FAQ’s
                    </Link>
                  </li>
                  <li>
                    <a
                      onClick={() => handleNavbarAccess()}
                      className="font-open text-[16px] leading-[26px] text-[#fff]"
                      href="/sitemap.xml"
                    >
                      Sitemap
                    </a>
                  </li>
                </ul>
              </div>

              <div className="">
                <h3 className="pb-[15px] font-open text-[20px] font-[600] leading-[30px] text-[#ffffff] md:pb-[24px]">
                  Support
                </h3>
                <ul className="flex flex-col gap-2">
                  {FooterSupport.map((item, idx) => {
                    return (
                      <li key={idx}>
                        <Link
                          onClick={() =>
                            item?.desc !== "Legal" && handleNavbarAccess()
                          }
                          className="font-open text-[16px] leading-[26px] text-[#fff]"
                          to={
                            token && !finYear && !finYearID ? false : item.path
                          }
                        >
                          {item.desc}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="mx-auto flex flex-col  justify-center gap-2 md:flex-nowrap">
             
            </div>

            <div className="flex flex-wrap gap-6  md:flex-nowrap  md:justify-center ">
              <div className="w-[50%] pt-[30px] md:ml-[10%] md:w-[50%]  md:pt-[0px]">
                <h3 className="pb-[15px] font-open text-[20px] font-[600] leading-[30px] text-[#ffffff] md:pb-[24px]">
                  Subscribe to Newsletter
                </h3>
                <form onSubmit={handleNewsletter} action="">
                  <div className="flex w-full items-center rounded-[8px] bg-[#D9DBE1] px-[12px] py-[8px]">
                    <input
                      className="w-full bg-[#D9DBE1] font-open text-[14px] leading-[24px] outline-0"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Your email address"
                    />
                    <button
                      onClick={() => handleNavbarAccess()}
                      type={
                        token
                          ? !finYear && !finYearID
                            ? ""
                            : "submit"
                          : "submit"
                      }
                    >
                      <BsSend />
                    </button>
                  </div>
                </form>

                <div className="mt-[30px]  font-open   leading-[30px] text-[#ffffff] md:pb-[24px]">
                  <div className="mb-[10px] flex items-center text-[20px] font-[600]">
                    Contact Info
                  </div>
                  <div className="flex w-fit items-center  font-open text-[16px] leading-[26px] text-[#fff] hover:text-pri-clr-orange">
                    <a href="tel:+919769699957" className="flex items-center">
                      <FaPhoneAlt className="mr-2" /> +91 9769699957
                    </a>
                  </div>

                  <div className="flex w-fit items-center font-open text-[16px] leading-[26px] text-[#fff] hover:text-pri-clr-orange">
                    <a
                      className="flex items-center"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="mailto:info@i4invest.in?subject=Inquiry&body=Hello,"
                    >
                      <MdMail className="mr-2 " /> info@i4invest.in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
